<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronRight_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.817 7.469 8.701 4.352a.623.623 0 1 0-.882.881l2.676 2.676-2.676 2.676a.623.623 0 1 0 .882.882l3.116-3.117a.623.623 0 0 0 0-.881m-3.636-.104L5.065 4.248a.623.623 0 1 0-.882.881L6.86 7.805l-2.676 2.677a.623.623 0 1 0 .882.88L8.18 8.247a.623.623 0 0 0 0-.881"
        clip-rule="evenodd"
    />
</svg>
